import React from "react";
import cx from "classnames";

const FormField = ({
  pre,
  children,
  label,
  value,
  values = [],
  type = "text",
  placeholder = "",
  help = "",
  error = false,
  onChange,
  onKeyDown,
  isSensitive,
  autoFocus,
  readOnly,
  disabled,
}) => (
  <div
    className={cx("form__field", { error: error })}
    data-hj-masked={isSensitive}
  >
    {label !== undefined && <label>{label}</label>}
    {values.length > 0 && (
      <select value={value} className="form__control" onChange={onChange}>
        {values.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    )}
    {pre}
    {values.length === 0 && children === undefined && (
      <input
        type={type}
        value={value || ""}
        className="form__control"
        placeholder={placeholder}
        onChange={onChange}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown || function () {}}
        readOnly={readOnly}
        disabled={disabled}
      />
    )}
    {children !== undefined && children}
    {help !== "" && <small className="form__help">{help}</small>}
  </div>
);

export default FormField;
